<h2 mat-dialog-title>New Case</h2>

<mat-dialog-content>
  <form [formGroup]="form" class="case-dialog-form br-flex br-flex-column br-gap-2 br-mt-1">

    <!-- Customer section -->
    <ng-container *ngIf="hasPrefilledCustomer">
      <div class="br-mb-1">
        <span class="br-form-label">Customer</span><br>
        <span class="case-dialog-customer">{{ data.customerName || ('ID: ' + data.customerId) }}</span>
      </div>
    </ng-container>

    <ng-container *ngIf="!hasPrefilledCustomer">
      <mat-form-field appearance="outline">
        <mat-label>Customer</mat-label>
        <input matInput [formControl]="customerCtrl" [matAutocomplete]="custAuto"
               placeholder="Search customer by name">
        <br-icon matSuffix>search</br-icon>
        <mat-autocomplete #custAuto="matAutocomplete" [displayWith]="displayCustomer"
                          (optionSelected)="onCustomerSelected($event.option.value)">
          <mat-option *ngFor="let c of customerOptions" [value]="c">{{ c.displayName }}</mat-option>
        </mat-autocomplete>
        <mat-hint *ngIf="!form.get('customerId')?.value">Pick a customer from the list.</mat-hint>
      </mat-form-field>
    </ng-container>

    <!-- Title -->
    <mat-form-field appearance="outline">
      <mat-label>Title</mat-label>
      <input matInput formControlName="title" maxlength="255">
      <mat-error *ngIf="form.get('title')?.hasError('required')">Required</mat-error>
      <mat-error *ngIf="form.get('title')?.hasError('maxlength')">Max 255 characters</mat-error>
    </mat-form-field>

    <!-- Description -->
    <mat-form-field appearance="outline">
      <mat-label>Description</mat-label>
      <textarea matInput formControlName="description" rows="3" maxlength="2000"></textarea>
    </mat-form-field>

    <!-- Related Ref -->
    <mat-form-field appearance="outline">
      <mat-label>Related Reference</mat-label>
      <input matInput formControlName="relatedRef" maxlength="128">
    </mat-form-field>

    <!-- Assigned To -->
    <mat-form-field appearance="outline">
      <mat-label>Assigned To</mat-label>
      <mat-select formControlName="assignedToUserId">
        <mat-option [value]="null">Unassigned</mat-option>
        <mat-option *ngFor="let u of users" [value]="u.id">{{ u.name }}</mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Follow-up (optional) -->
    <div class="br-flex br-gap-3">
      <app-date-field class="br-flex-grow-1 br-min-w-0" label="Follow-up date (optional)" formControlName="followUpOn"></app-date-field>
      <app-time-field class="br-flex-grow-1 br-min-w-0" label="Follow-up time (optional)" formControlName="followUpTime"
                      [disabled]="!form.get('followUpOn')?.value"></app-time-field>
    </div>

  </form>
</mat-dialog-content>

<mat-dialog-actions align="end" class="br-gap-2">
  <button type="button" class="br-btn br-btn--outline-secondary" (click)="cancel()">Cancel</button>
  <button type="button" class="br-btn br-btn--primary" (click)="submit()"
          [disabled]="form.invalid || saving">
    Create
  </button>
</mat-dialog-actions>
